<!--page starts-->
<section class="page-wrapper">
    <div class="commercial-top-section margin-top-152 cf" style="background-image: url(assets/images/commercial-bg.jpg);">
        <div class="container">
            <div class="commercial-top-tab-list ">
                <div class="commercial-top-tab-list-inner">
                    <div class="commercial-top-tab-list-detail">
                        <ul>
                            <li><a routerLink="/club" >How To Find Us </a></li>
                            <li><a routerLink="/ground-regulations" >Ground Regulations</a></li>
                            <li><a routerLink="/access-statement" >Access Statement</a></li>
                            <li><a routerLink="/recruitment">Recruitment</a></li>
                            <li><a routerLink="/governance" class="active"> Governance</a></li>                                                          
                        </ul>
                    </div>
                    <div class="commercial-top-mouse">
                        <div class="commercial-top-mouse-img">
                            <img src="assets/images/mouse.svg">
                        </div>
                        <p>scroll for details</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="commercial-top-overlay">
        </div>
    </div>
    <div class="club-hero-section cf">
        <div class="container">
            <div class="club-hero-detail">
               <div class="club-rules-section">
                    <div class="titel-box">
                        <h2 class="titel-name">Club Rules</h2>
                    </div>
                    <div class="club-rules-content">
                        <p>Here are the Club Rules of Leicestershire CCC. These were last amended at the Special General Meeting on 15.01.19:</p>
                    </div>
                    <div class="club-rules-btn">
                        <ul>
                            <li><a href="javascript:void(0)">Get Club Rules</a></li>
                        </ul>
                    </div>
               </div>
               <div class="annual-general-section">
                    <div class="titel-box">
                        <h2 class="titel-name">Annual General Meeting (AGM) Minutes</h2>
                    </div> 
                    <div class="club-rules-content">
                        <p>Here are the minutes from previous AGMs:</p>
                    </div>
                    <div class="club-annual-general-btn">
                        <ul>
                            <li><a href="javascript:void(0)">2018</a></li>
                            <li><a href="javascript:void(0)">2017</a></li>
                            <li><a href="javascript:void(0)">2016</a></li>
                            <li><a href="javascript:void(0)">2015</a></li>
                            <li><a href="javascript:void(0)">2014</a></li>
                        </ul>
                    </div>
               </div>
               <div class="club-agm">
                    <div class="titel-box">
                        <h2 class="titel-name">2020 AGM </h2>
                    </div> 
                    <div class="club-rules-content">
                        <p>Here some documentation for the 2020 AGM:</p>
                    </div>
                    <div class="club-agm-btn">
                        <ul>
                            <li><a href="javascript:void(0)">Notice of AGM & Agenda</a></li>
                            <li><a href="javascript:void(0)">Director Profiles for 2020 ….</a></li>
                            <li><a href="javascript:void(0)">Form of Proxy</a></li>
                            <li><a href="javascript:void(0)">Annual Report & Accounts 2019</a></li>
                            <li><a href="javascript:void(0)">Board of Directors</a></li>
                        </ul>
                    </div>
               </div>
               <div class="club-agm-bottom">
                    <div class="club-rules-content">
                        <p>Here is a series of articles with links to the process undertaken for the 2020 AGM:</p>
                    </div> 
                    <div class="club-agm-bottom-btn">
                        <ul>
                            <li><p>Monday, March 2, 2020</p><a href="javascript:void(0)">Article 01</a></li>
                            <li><p>Monday, March 17, 2020</p><a href="javascript:void(0)">Article 01</a></li>
                            <li><p>Monday, March 24, 2020</p><a href="javascript:void(0)">Article 01</a></li>
                            <li><p>Thursday, March 26, 2020</p><a href="javascript:void(0)">Article 01</a></li>
                        </ul>
                    </div>
               </div>
            </div>
        </div>
    </div>
</section><!-- page ends-->